import { useHits } from 'react-instantsearch';
import SearchHitListItem from '../search-hit-list-item/search-hit-list-item';
import type { SearchHit } from '../search/search-hit-types';

export function SearchHitsList() {
    const { hits } = useHits<SearchHit>();

    return (
        <div>
            <ul>
                {hits.map((hit) => {
                    return (
                        <li
                            className="my-8"
                            key={hit.objectID}
                            data-insights-object-id={hit.objectID}
                            data-insights-position={hit.__position}
                            data-insights-query-id={hit.__queryID}
                        >
                            <SearchHitListItem hit={hit} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default SearchHitsList;
